var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BoxWrap",
    { staticClass: "m-salesKPIRecord", attrs: { "no-title": "" } },
    [
      _c("div", { staticClass: "flexRow salesKPIRecordContent" }, [
        _c(
          "div",
          { staticClass: "flexLeft" },
          [
            _c(
              "InfoItem",
              {
                attrs: {
                  title: "1." + _vm.$t("storeComponents.title.TPP"),
                  "without-drop": "",
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "tppDataForm",
                    staticClass: "formGroup",
                    attrs: {
                      model: _vm.tppForm,
                      size: "small",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "radioGroup",
                            model: {
                              value: _vm.tppForm.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.tppForm, "type", $$v)
                              },
                              expression: "tppForm.type",
                            },
                          },
                          [
                            _c(
                              "el-radio-button",
                              { attrs: { label: "1", name: "type" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("storeComponents.form.month"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio-button",
                              { attrs: { label: "2", name: "type" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("storeComponents.form.quarter"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio-button",
                              { attrs: { label: "3", name: "type" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("storeComponents.form.year"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("storeComponents.form.brand") },
                      },
                      [
                        _c("FormSelect", {
                          attrs: {
                            val: _vm.tppForm.brand,
                            options: _vm.ssbtypeOptions,
                            clearable: false,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(_vm.tppForm, "brand", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.formatTimeLabel } },
                      [
                        _vm.tppForm.type == "1"
                          ? _c("FormDatePicker", {
                              attrs: {
                                val: _vm.tppForm.value,
                                valueformat: "yyyyMM",
                                type: "month",
                                clearable: false,
                                editable: false,
                                placeholder: _vm.$t(
                                  "storeComponents.common.pleaseSelectMonth"
                                ),
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(_vm.tppForm, "value", $event)
                                },
                              },
                            })
                          : _vm.tppForm.type == "2"
                          ? _c("FormQuarterPicker", {
                              attrs: {
                                val: _vm.tppForm.value,
                                placeholder: _vm.$t(
                                  "storeComponents.common.pleaseSelectQuarter"
                                ),
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(_vm.tppForm, "value", $event)
                                },
                              },
                            })
                          : _vm.tppForm.type == "3"
                          ? _c("FormDatePicker", {
                              attrs: {
                                val: _vm.tppForm.value,
                                valueformat: "yyyy",
                                type: "year",
                                clearable: false,
                                editable: false,
                                placeholder: _vm.$t(
                                  "storeComponents.common.pleaseSelectYear"
                                ),
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(_vm.tppForm, "value", $event)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "desc" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("storeComponents.common.desc" + _vm.tppForm.type)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tppChartBox" }, [
                  _c("div", { staticClass: "transformBox" }, [
                    _c("div", {
                      staticClass: "tppChartCt",
                      attrs: { id: "id_tppCompRate" },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tppDateItem" }, [
                  _c("div", { staticClass: "line color3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(_vm._s(_vm.$t("storeComponents.title.tppRate"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nums" }, [
                    _c("span", { staticClass: "num1" }, [
                      _vm._v(_vm._s(_vm.removeUnit(_vm.tppInfo))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "num2" }, [_vm._v("%")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tppDateItem" }, [
                  _c("div", { staticClass: "line color1" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(_vm._s(_vm.$t("storeComponents.title.tppCount"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nums" }, [
                    _c("span", { staticClass: "num1" }, [
                      _vm._v(_vm._s(_vm.tppInfo.confirmedCount)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "num2" }, [
                      _vm._v("/" + _vm._s(_vm.tppInfo.tppTargetCount)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tppDateItem" }, [
                  _c("div", { staticClass: "line color2" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(
                      _vm._s(_vm.$t("storeComponents.title.tppUnfinishCount"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nums" }, [
                    _c("span", { staticClass: "num1" }, [
                      _vm._v(_vm._s(_vm.tppInfo.unFinishedCount)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "num2" }, [
                      _vm._v("/" + _vm._s(_vm.tppInfo.tppTargetCount)),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flexRight" },
          [
            _c(
              "InfoItem",
              {
                attrs: {
                  title:
                    "2." + _vm.$t("storeComponents.title.monthlyActualSales"),
                  "without-drop": "",
                },
              },
              [
                _c("div", {
                  staticClass: "chartCt",
                  attrs: { id: "id_monthlyActualSales" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "InfoItem",
              {
                attrs: {
                  title:
                    "3." + _vm.$t("storeComponents.title.quarterActualSales"),
                  "without-drop": "",
                },
              },
              [
                _c("div", {
                  staticClass: "chartCt",
                  attrs: { id: "id_quarterActualSales" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "InfoItem",
              {
                attrs: {
                  title: "4." + _vm.$t("storeComponents.title.orderStatus"),
                  "without-drop": "",
                },
              },
              [
                _c("div", { staticClass: "flexRow" }, [
                  _c(
                    "div",
                    { staticClass: "queryLabel" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "orderDataForm",
                          staticClass: "formGroup",
                          attrs: {
                            model: _vm.orderForm,
                            size: "small",
                            "label-position": "top",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeComponents.form.month"),
                              },
                            },
                            [
                              _c("FormDatePicker", {
                                attrs: {
                                  val: _vm.orderForm.month,
                                  valueformat: "yyyyMM",
                                  type: "month",
                                  clearable: false,
                                  editable: false,
                                  placeholder: _vm.$t(
                                    "storeComponents.common.pleaseSelectMonth"
                                  ),
                                },
                                on: {
                                  "update:val": function ($event) {
                                    return _vm.$set(
                                      _vm.orderForm,
                                      "month",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flexRight" }, [
                    _c("div", { staticClass: "progressGroup" }, [
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "storeComponents.common.targetSalesMonth"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.salesTargetQty,
                              color: "#004EA8",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.orderStatus.salesTargetQty +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("storeComponents.common.numberOfOrders")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.orderQty,
                              color: "#A7CAF2",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.orderStatus.orderQty +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "storeComponents.common.numberOfConfirmations"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.confirmedQty,
                              color: "#FEDB00",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.orderStatus.confirmedQty +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }